<template>
  <div class="pay-successCon">
    <div class="pay-success flexJC alignItem">
      <span class="paySuccess-icon mb22"></span>
      <p class="f28 mb20">支付成功</p>
      <p class="color-9 f18">您已付款成功，正在跳转</p>
      <p class="color-9 f18 pt5">请稍后...</p>
    </div>

    <!-- <audio id="audio_door_opened" width="1" height="1" preload="auto">该浏览器不支持audio属性</audio> -->
    <audio id="audio_door_opened" style="display: none;" src="https://www.aigehui028.com/static/mp/audios/wh-door-opened.aac" preload="auto"></audio>
  </div>
</template>
<script>
import cabinetServ from '../service/cabinetServ'
import cache from '../service/cacheServ'
import mintUi from '../lib/mint-ui'
export default {
  data() {
    return {
      count: '',
      isLoading: false
    }
  },
  created() {
    let cabinetNo = cache.get('cabinetInfo').cabinet.cabinetNo
    let customerWxId = cache.get('user').openId
    let orderNum = this.$route.query.orderNo
    let qrCode = this.$route.query.qrCode
    setTimeout(() => {
      this.getOpenDor(cabinetNo, orderNum, customerWxId, qrCode)
    }, 3600);
  },
  methods: {
    // 定义音乐的自动播放事件
    audioAutoPlay(id) {
      var audio = document.getElementById(id);
      if (window.WeixinJSBridge) {
        WeixinJSBridge.invoke('getNetworkType', {}, function (e) {
          audio.play();
        }, false);
      } else {
        document.addEventListener("WeixinJSBridgeReady", function () {
          WeixinJSBridge.invoke('getNetworkType', {}, function (e) {
            audio.play();
          });
        }, false);
      }
      audio.play();

      return false;
    },
    // 查询柜门是否打开
    async getOpenDor(cabinetNo, orderNo, customerWxId, qrCode) {
      // var tryNum = 1;
      let res = await cabinetServ.getIsOpenDoor(cabinetNo, orderNo, customerWxId, qrCode)


      //alert(JSON.stringify(res))
      if (200 === +res.code) {
        if (res.data.cabinetStatus == 'online') { // 在线
          if (!res.data.orderStatus) {
            mintUi.Toast({
              message: '订单不存在，如有疑问请联系管理员',
              position: 'bottom'
            })
          } else {
            if (1 === +res.data.orderStatus) { // 已支付
              if (parseInt(res.data.doorId) > 0) {// 已支付 门已开
                this.audioAutoPlay('audio_door_opened');
                setTimeout(() => {
                  this.$router.push({ path: '/openSuccess', query: { qrCode: qrCode, orderNo: orderNo } })
                }, 4000);
              } else { // 已支付 门未开 去开门
                this.$router.push({ path: '/openDoorUnSuccess', query: { qrCode: qrCode, orderNo: orderNo } })
              }
            } else if (2 === +res.data.orderStatus) {// 已借出
              this.audioAutoPlay('audio_door_opened');
              setTimeout(() => {
                this.$router.push({ path: '/openSuccess', query: { qrCode: qrCode, orderNo: orderNo } })
              }, 4000);
            } else { // 其他状态去异常页面
              this.$router.push({ path: '/noNormal', query: { qrCode: qrCode, orderNo: orderNo } })
            }
          }
        } else {
          this.$router.push({ path: '/noNormal', query: { qrCode: qrCode, orderNo: orderNo } })
        }
      } else {
        this.$router.push({ path: '/noNormal', query: { qrCode: qrCode, orderNo: orderNo } })
      }
    },
    goToUrl() {
      window.location.href = 'http://www.aigehui028.com/'
    }
  }
}
</script>

<style lang="less" scoped>
.pay-successCon {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: white;
  z-index: 2;
}
.pay-success {
  padding-top: 100px;
}
.pt5 {
  padding-top: 5px;
}
.paySuccess-icon {
  width: 57px;
  height: 57px;
  background: url("/static/images/paySuccess-icon.png") no-repeat;
  background-size: 100% 100%;
}
</style>




// WEBPACK FOOTER //
// src/pages/paySuccess.vue